import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'
import {
  defaultGetStaticPaths,
  getLocaleFromContext
} from '../../utils/staticGeneration'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { GetStaticProps, NextPage } from 'next'

// Default static site generation.
export const getStaticPaths = defaultGetStaticPaths
export const getStaticProps: GetStaticProps = async (context) => ({
  props: {
    ...(await serverSideTranslations(getLocaleFromContext(context), ['common']))
  }
})

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    minHeight: '40vh',
    margin: theme.spacing(10, 3, 8, 3),
    maxWidth: '600px',
    color: theme.palette.primary.main
  },
  heading: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(3)
  },
  text: {
    color: theme.palette.primary.main,
    fontSize: '1rem',
    lineHeight: 1.5,
    '& > ul > li > a': {
      color: theme.palette.primary.main
    }
  },
  h6: {
    fontWeight: 'bold',
    lineHeight: 2
  },
  p: {
    marginBottom: theme.spacing(2),
    whiteSpace: 'pre-line'
  }
}))

const PrivacyPolicyPage: NextPage = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  return (
    <>
      <Head>
        <title>{t('Privacy policy')} - Live Klassisk</title>
        <meta
          name='description'
          content={t(
            'This page is used to inform visitors about Live Klassisk’ policies with the collection, use, and disclosure of personal information.'
          )}
        />
      </Head>
      <Grid container className={classes.root} justifyContent='center'>
        <Grid container className={classes.container}>
          <Typography variant='h2' className={classes.heading}>
            {t('Privacy policy')}
          </Typography>
          <div className={classes.text}>
            <Typography className={classes.p}>
              {t(
                'This page is used to inform visitors about our policies with the collection, use, and disclosure of personal information if anyone decided to use our service.\n\nIf choosing to use our service, then you agree to the collection and use of information in relation to this policy. The personal information that we collect is used for providing and improving the service. We will not use or share your information with anyone except as described in this privacy policy.\n\nInformation collection and use\n\nFor a better experience, while using our service, we may require you to provide us with certain personally identifiable information. The information that we request will be retained by us and used as described in this privacy policy.\n\nCookies\n\nCookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your devices memory.\n\nYou have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of our service.\n\nLinks to other sites\n\nThis service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.\n\nChanges to this privacy policy\n\nWe may update our privacy policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new privacy policy on this page. These changes are effective immediately after they are posted on this page.\n\nContact us\n\nIf you have any questions or suggestions about our privacy policy, do not hesitate to contact us.\n\nLink to privacy policy of third party service providers'
              )}
            </Typography>
            <ul>
              <li>
                <a
                  href='https://google.com/analytics/terms/us.html'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Google Analytics
                </a>
              </li>
              <li>
                <a
                  href='https://mailchimp.com/legal/privacy/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Mailchimp
                </a>
              </li>
            </ul>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default PrivacyPolicyPage
